const planningRoutesUrls = {
  overview: `/planning`,
  order: `/planning/order/:orderUuid`,
  driver: `/planning/driver/:driverUuid`,
};

export default planningRoutesUrls;
